import './Landing.scss';
import Preview from '../../Components/Preview/Preview.jsx';

const Landing = () => {
  return (
    <>
      <div style={{ margin: '20px 0 0' }}>
        <h3 className="able-to-search">可以搜尋到這些書</h3>
      </div>
      <Preview />
    </>
  );
};

export default Landing;
